import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {Command} from '../model/command.model';
import {environment} from '../../environments/environment';

export class MyIp {
  // tslint:disable-next-line:variable-name
  my_ip = '';
}

export class Device {
  region: string;
  city: string;
}

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  endPoint = environment.api_endpoint;

  constructor(
    private httpClient: HttpClient
  ) { }


  httpError(error): Observable<any> {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client side error
      msg = error.error.message;
    } else {
      // server side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(msg);
    return throwError(msg);
  }


  getMyIp(): Observable<MyIp> {
    return this.httpClient.get<MyIp>(this.endPoint + '/api/myip')
      .pipe(
        retry(1),
        catchError(this.httpError)
      );
  }

  getDevices(): Observable<Device> {
    return this.httpClient.get<Device>(this.endPoint + '/api/devices')
      .pipe(
        retry(1),
        catchError(this.httpError)
      );
  }

  postCommand(command: Command): Observable<string> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.endPoint + '/api/command',
      JSON.stringify(command),
      { headers, responseType: 'text'})
      .pipe(
        retry(1),
        catchError(this.httpError)
      );
  }
}
